<template>
        <div class="card-item schCon" style="overflow-y: scroll;background-color: #F2F3F6">
            <p class="flex-box al-c mb10" style="color: #024A84;">
                <img :src="`${baseUrl}images/${itemData.code}.png`" alt="">
                <span class="ml10 font-14" :style="{'font-size': type == 'index' ? '20px' : '14px'}">校历</span>
                <span style="color: #333333;padding-left: 20px;font-size: 12px">{{calData.title}}</span>
                <span style="color: #333333;font-size: 12px">({{calData.startDate}} 至 {{calData.endDate}})</span>
                <!--<i class="el-icon-plus" style="padding-left: 10px" @click="addSc"></i>-->
            </p>
            <div class="cont">
                <div class="cont-left">
                    <div>校历周</div>
                    <p v-for="(item,index) in weekList" :key="index">{{item == '' ?  '' : '第'+item+'周'}}</p>
                </div>
                <el-calendar
                        v-model="value"
                >
                    <template
                            slot="dateCell"
                            slot-scope="{date, data}">
                        <!--自定义内容-->
                        <div>
                            <div class="calendar-day">{{ data.day.split('-').slice(2).join('-') }}</div>
                            <div v-for="(item, index) in calendarData " :key="index">
                                <div v-if="(item.months).indexOf(data.day.split('-').slice(1)[0])!=-1">
                                    <div v-if="(item.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
                                        <el-tooltip class="item" effect="dark" :content="item.things" placement="right">
                                            <div class="is-selected" style="width: 36px">{{item.things | ellipsis}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div v-else></div>
                                </div>
                                <div v-else></div>
                            </div>
                        </div>
                    </template>
                </el-calendar>
            </div>
        </div>
</template>

<script>
    import {getCalendar} from '@/api/management/showcase'
    export default {
        name: "SchoolDate",
        props:['itemData', 'type'],
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                value: '',
                addDateShow: false,
                form: {
                    name: '',
                    region: '',
                    times: ''
                },
                formLabelWidth: '120px',
                calData: {},
                weekList: [],
                calendarData: [],
                parmMon: '',
            }
        },
        created(){
        },
        mounted(){
            this.getCalendarList()
            this.$nextTick(() => {
                // 点击前一个月
                let prevBtn = document.querySelector(
                    '.el-calendar__button-group .el-button-group>button:nth-child(1)');
                prevBtn.addEventListener('click', () => {
                    let date = new Date(this.value)
                    let monDate = (date.getMonth() + 1) < 10 ? '0'+ (date.getMonth() + 1) : (date.getMonth() + 1)
                    this.parmMon = date.getFullYear() + '-' + monDate
                    this.getCalendarList()
                })
            }),
            this.$nextTick(() => {
                // 点击后一个月
                let prevBtn = document.querySelector(
                    '.el-calendar__button-group .el-button-group>button:last-child');
                prevBtn.addEventListener('click', () => {
                    let date = new Date(this.value)
                    let monDate = (date.getMonth() + 1) < 10 ? '0'+ (date.getMonth() + 1) : (date.getMonth() + 1)
                    this.parmMon = date.getFullYear() + '-' + monDate
                    this.getCalendarList()
                })
            })
        },
        methods: {
            //获取校历周
            getCalendarList(){
                let params = {
                    dateStr: this.parmMon || ''
                }
                getCalendar(params).then(({data}) =>{
                    this.calData = data.data
                    this.weekList = (data.data || {}).weekArr || []
                    this.calendarData = (data.data || {}).thingArr || []
                })
            },
            // 添加事件
            addSc(){
                this.addDateShow = true
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        },
        filters: {
            ellipsis(value) {
                if (!value) return "";
                if (value.length > 2) {
                    return value.slice(0, 2) + "...";
                }
                return value;
            }
        },
    }
</script>

<style scoped lang="less">
    .schCon{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 200px;
    }
    .schCon::-webkit-scrollbar {
        display: none;
    }
    .dateTop{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 4px 0;
        i{
            padding: 0 5px;
        }
    }
    .cont{
        background-color: #F2F3F6;
        display: flex;
        justify-content: flex-start;
        .cont-left{
            padding-top: 36px;
            div{
                width: 60px;
                text-align: center;
                height: 31px;
                line-height: 31px;
                padding: 6px 0;
            }
            p {
                width: 60px;
                height: 48px;
                line-height: 48px;
                padding: 4px 0;
                text-align: center;
            }
        }
    }

</style>
<style>
    /*.el-calendar__body{*/
        /*padding: 6px 10px 20px 0;*/
    /*}*/
    .el-calendar {
        background-color: #F2F3F6;
    }
    .el-calendar-table .el-calendar-day {
        padding: 4px;
        height: 48px;
        font-size: 12px;
        text-align: center;
    }
    .el-calendar__header{
        padding: 4px 5px;
    }
    .el-calendar-table thead th{
        padding: 6px 0;
    }
    .el-calendar__body{
        padding: 0px !important ;
    }
    .el-button-group>.el-button:not(:first-child):not(:last-child) {
        display: none;
    }
</style>